export const ReturnStatus: { [key: string] : any }  = {
    waiting: "Обработва се",
    disputed : "Обжалвана",
    confirmed : "Възстановена",
    cancelled : "Отказана"
}